const TeamSection = () => {
  const teamMembers = [
    {
      name: "Alex Rivera",
      role: "Founder & Lead Artist",
      bio: "Passionate about resin art with over 5 years of experience creating unique pieces.",
      image: "/placeholder.svg?height=300&width=300",
    },
    {
      name: "Jordan Kim",
      role: "Design Specialist",
      bio: "Specializes in custom designs and color combinations to bring your vision to life.",
      image: "/placeholder.svg?height=300&width=300",
    },
    {
      name: "Taylor Brown",
      role: "Quality Assurance",
      bio: "Ensures every piece meets our high standards of craftsmanship and quality.",
      image: "/placeholder.svg?height=300&width=300",
    },
  ]

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Meet Our Team</h2>
          <p className="text-lg text-gray-600">Introduction to the RangDesaaj team and their passion for resin art.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center bg-white rounded-lg p-6 shadow-sm">
              <div className="w-32 h-32 bg-gray-200 rounded-full mx-auto mb-4 overflow-hidden">
                <img
                  src={member.image || "/placeholder.svg"}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
              <p className="text-black font-medium mb-3">{member.role}</p>
              <p className="text-gray-600 text-sm">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TeamSection
